import { render, staticRenderFns } from "./ApprovalVideoReject.vue?vue&type=template&id=365ffad0&"
import script from "./ApprovalVideoReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalVideoReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports